import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ExamService from "../../service/exam.service";
import PageNavigation from "../components/PageNavigation";
const config = require("../../../configs/config.json");

export default function ApplicationDetail() {
    const { assignmentId } = useParams();
    const [data, setData] = useState(null);
    const [examName, setExamName] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showOnlyAnswered, setShowOnlyAnswered] = useState(true);

    useEffect(() => {
        if (!assignmentId) {
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(null);
        ExamService.getAssignmentAnswers(assignmentId)
            .then((res) => {
                if (res) setData(res);
                else setError("Veri yüklenemedi.");
            })
            .catch((err) => {
                setError(err?.message || "Veri yüklenemedi.");
            })
            .finally(() => {
                setLoading(false);
            });
    }, [assignmentId]);

    useEffect(() => {
        if (!data?.examId) return;
        ExamService.getExamById(data.examId)
            .then((exam) => setExamName(exam?.name ?? null))
            .catch(() => setExamName(null));
    }, [data?.examId]);

    if (loading) {
        return (
            <div className="p-4">
                <PageNavigation main="Applications" sub="Home" header="Sınav Detayı" description="Öğrenci cevapları" />
                <div className="card card-body shadow border-0 mt-3">
                    <p className="text-muted mb-0">Yükleniyor...</p>
                </div>
            </div>
        );
    }

    if (error || !data) {
        return (
            <div className="p-4">
                <PageNavigation main="Applications" sub="Home" header="Sınav Detayı" description="Öğrenci cevapları" />
                <div className="card card-body shadow border-0 mt-3">
                    <p className="text-danger mb-2">{error || "Kayıt bulunamadı."}</p>
                    <Link to="/applications/" className="btn btn-outline-secondary btn-sm">Listeye dön</Link>
                </div>
            </div>
        );
    }

    const base = config.api.invokeUrl;
    const previewUrl = (recordedFileId) =>  `${base}/storage/preview/audio/${recordedFileId}`;
    
    const parts = data.examResultActivityParts || [];
    const groupedByActivity = parts.reduce((acc, part) => {
        const key = part.activityGroup ?? "OTHER";
        if (!acc[key]) acc[key] = [];
        acc[key].push(part);
        return acc;
    }, {});

    const Row = ({ label, value }) => (
        <div className="d-flex align-items-baseline gap-2 flex-wrap">
            <span className="text-muted small">{label}:</span>
            <span className="mb-0">{value ?? "—"}</span>
        </div>
    );

    return (
        <div className="p-4">
            <PageNavigation main="Applications" sub="Home" header="Sınav Detayı" description="Öğrenci cevapları" />
            <div className="card card-body shadow border-0 mt-3">
                <div className="d-flex flex-wrap gap-3 mb-4 pb-3 border-bottom">
                    <div className="d-flex align-items-baseline gap-1"><span className="text-muted small">Öğrenci:</span> <strong>{(data.studentName || data.student?.name) ?? data.studentId ?? "—"}</strong></div>
                    <div className="d-flex align-items-baseline gap-1"><span className="text-muted small">Sınav:</span> <strong>{examName ?? data.examName ?? data.exam?.name ?? data.examId ?? "—"}</strong></div>
                    <div className="d-flex align-items-baseline gap-1"><span className="text-muted small">Assignment ID:</span> <strong>{data.assignmentId ?? "—"}</strong></div>
                    {data.score != null && <div className="d-flex align-items-baseline gap-1"><span className="text-muted small">Puan:</span> <strong>{data.score}</strong></div>}
                </div>
                <div className="mb-3">
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => setShowOnlyAnswered((v) => !v)}
                    >
                        {showOnlyAnswered ? "TÜMÜNÜ GÖSTER" : "CEVAPLANANLARI GÖSTER"}
                    </button>
                </div>

                <h6 className="mb-3">Cevaplar</h6>
                <div className="d-flex flex-column gap-4">
                    {parts.length === 0 ? (
                        <p className="text-muted small mb-0">Henüz cevap kaydı yok.</p>
                    ) : (
                        Object.entries(groupedByActivity).map(([activityGroup, groupParts]) => {
                            const sorted = [...groupParts].sort((a, b) => (a.orderNumber ?? 0) - (b.orderNumber ?? 0));
                            const filtered = showOnlyAnswered
                                ? sorted.filter((p) => p.studentScore != null && Number(p.studentScore) > 0)
                                : sorted;
                            if (filtered.length === 0) return null;
                            return (
                                <div key={activityGroup}>
                                    <h6 className="text-secondary small text-uppercase mb-2">{activityGroup}</h6>
                                    <div className="d-flex flex-column gap-3">
                                        {filtered.map((part, index) => {
                                            const isAnswered = part.studentScore != null && Number(part.studentScore) > 0;
                                            const borderClass = isAnswered ? "border-success" : "border-danger";
                                            return (
                                            <div key={index} className={`border border-2 rounded p-3 bg-light ${borderClass}`}>
                                                <div className="d-flex flex-column gap-2">
                                                    <Row label="Soru" value={part.content} />
                                                    <Row label="Cevap" value={part.answer} />
                                                    <Row label="Öğrenci cevabı (metin)" value={part.studentAnswer} />
                                                    <Row label={`Puan (Max: ${part.score ?? "—"})`} value={part.studentScore} />
                                                </div>
                                                {part.recordedFileId && (
                                                    <div className="mt-2">
                                                        <div className="d-flex align-items-baseline gap-2 mb-1">
                                                            <span className="text-muted small">Ses kaydı:</span>
                                                        </div>
                                                        <audio
                                                            controls
                                                            preload="metadata"
                                                            src={previewUrl(part.recordedFileId)}
                                                            className="w-100"
                                                        >
                                                            Tarayıcınız ses öğesini desteklemiyor.
                                                        </audio>
                                                    </div>
                                                )}
                                            </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>

                <div className="mt-4 pt-3 border-top">
                    <Link to="/applications/" className="btn btn-outline-secondary btn-sm">Listeye dön</Link>
                </div>
            </div>
        </div>
    );
}
